const minin = {
  data() {
    return {
      formCtrl: [
        {
          keyName: "predict_loading_date",
          label: "装货日期：",
          type: "date",
          placeholder: "选择日期",
        },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchDateOptions: [
        { keyName: "predict_loading_date", label: "装货日期", },
        { keyName: "predict_unloading_date", label: "卸货日期", },
      ],
      searchKeyOptions: [
        { label: '客户名称', value: 'shname', },
        { label: '车牌号', value: 'license', },
      ],
      baseParams: ['ischeck', 'isstatus'],
    };
  },
  methods: {
    delete({ order_num }) {
      console.log('order_num', order_num)
      this.$prompt('删除原因', '确认删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.delReq(order_num, value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    delReq(order_num, del_desc) {
      this.loading = true
      let url = `order/delorder`;
      const params = {
        userid: this.user.id,
        order_num,
        del_desc
      }
      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
    showPosition({ license, is_gps }) {
      if (is_gps != 1) {
        this.$message({
          type: 'error',
          message: '未绑定定位设备!'
        });
        return;
      }
      console.log(license)
      // return
      this.$router.push(`/order/position?license=${license}`)
    },
  },
  mounted() {
    this.getList()
  },
}

export default minin